var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 28.5674L30.5833 28.7147M13.7491 36H25.9158C28.1249 36 29.9158 34.2091 29.9158 32V7C29.9158 4.79086 28.1249 3 25.9158 3H13.7491C11.54 3 9.74911 4.79086 9.74911 7V32C9.74911 34.2091 11.54 36 13.7491 36Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9878 33.7734C20.7472 33.7734 21.3628 33.1578 21.3628 32.3984C21.3628 31.639 20.7472 31.0234 19.9878 31.0234C19.2284 31.0234 18.6128 31.639 18.6128 32.3984C18.6128 33.1578 19.2284 33.7734 19.9878 33.7734Z",
    fill: "#76BC21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.868 5.67578H18.6597C18.28 5.67578 17.9722 5.98359 17.9722 6.36328C17.9722 6.74298 18.28 7.05078 18.6597 7.05078H21.868C22.2477 7.05078 22.5555 6.74298 22.5555 6.36328C22.5555 5.98359 22.2477 5.67578 21.868 5.67578Z",
    fill: "#76BC21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMin);
export default __webpack_public_path__ + "static/media/min.2f28e440887ee6c381b8feb1b66e1c35.svg";
export { ForwardRef as ReactComponent };